import PageTemplate from "./PageTemplate.vue";

export * from "./pageTemplate.types";

export default PageTemplate;
